import { render, staticRenderFns } from "./PicZoom.vue?vue&type=template&id=1333f8e0&scoped=true&"
import script from "./PicZoom.vue?vue&type=script&lang=js&"
export * from "./PicZoom.vue?vue&type=script&lang=js&"
import style0 from "./PicZoom.vue?vue&type=style&index=0&id=1333f8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333f8e0",
  null
  
)

export default component.exports